import React from 'react';

import { Container } from './styles';

const ModalFooter: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ModalFooter;
